import * as React from 'react'
import { Icon as LegacyIcon } from '@ant-design/compatible'
import { Tooltip } from 'antd'
import titleCase from 'title-case'
import { IBadgeProps } from '@halo/components/badges/badge-props.interface'
import './status-badge.scss'
import { PropsWithChildren } from 'react'

type StatusBadgeType = 'generic' | 'account' | 'domain' | 'billing' | 'access' | 'user'

/*
    "expanded" view forces hidden tooltip
    and displays the status text to the right
    of the badge
 */
interface IProps extends IBadgeProps {
    type: StatusBadgeType
    status: string
    expanded?: boolean
    map?: { [key: string]: string }
}

export const StatusBadge: React.FC<IProps> = (props) => {
    const hideTooltip = props.hideTooltip ?? props.expanded

    let text = props.status
    let icon = 'check-circle'
    let theme: 'filled' | undefined

    if (props.status === 'DISABLED') {
        icon = 'pause-circle'
    }

    if (props.type === 'billing') {
        switch (props.status) {
            case 'OPEN':
                icon = 'info-circle'
                break
            case 'PENDING':
                icon = 'clock-circle'
                break
            case 'UNCONFIRMED':
                icon = 'exclamation-circle'
                break
            case 'REFUNDED':
                icon = 'undo'
                break
            case 'FAILED':
                icon = 'warning'
                theme = 'filled'
                break
        }
    } else if (props.type === 'generic') {
        switch (props.status) {
            case 'EXPIRED':
                icon = 'exclamation-circle'
                break
        }
    } else if (props.type === 'access') {
        switch (props.status) {
            case 'DENIED':
                icon = 'exclamation-circle'
                break
        }
    } else if (props.type === 'user') {
        theme = 'filled'

        switch (props.status) {
            case 'INVITED':
                icon = 'mail'
                break
            case 'PASSWORD_RESET':
                icon = 'lock'
                break
            case 'DISABLED':
                icon = 'close-circle'
                break
        }
    }

    if (icon === 'check-circle') {
        theme = 'filled'
    }

    const badge = (
        <span className={`status-icon status-${text}`}>
            <LegacyIcon type={icon} theme={theme} />
        </span>
    )

    const BadgeTooltip: React.FC<PropsWithChildren<any>> = ({ children }) =>
        hideTooltip ? (
            <>{children}</>
        ) : (
            <Tooltip className="tooltip" title={props.tooltip || text}>
                {children}
            </Tooltip>
        )

    return (
        <span className={`status-badge ${props.type}-status-badge`}>
            <BadgeTooltip>
                {badge}
                {!props.expanded ? undefined : <span className="status-name">{titleCase(text)}</span>}
            </BadgeTooltip>
        </span>
    )
}
